import React, { Fragment, useEffect, useState,useContext } from "react";
import Affix from "react-simple-affix";
import MapRouteThumb from "../MapRoute/MapRouteThumb";
import i18next from "i18next";
import cookies from "js-cookie";
import LanguageContext from "./../../store/language-context";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function SuggestedRoutes() {
  const [pois, initPois] = useState([])

  const controller = new AbortController();
  const { signal } = controller;

    const languageCtx = useContext(LanguageContext);

    const { t } = useTranslation();
    const fetchData = async () => {

    const pid = window.location.pathname.split("/").pop();
    const furl = `https://folegandros.mitos.cityguideplatform.com/api/pois?lang=${languageCtx.languageCode}`;
      
    const response = await fetch(furl, {signal,
      headers: {
        'X-API-KEY': '8J5Yymc2pXzPUZnrqqYR',
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    if (!response.ok) {
      throw new Error('Data coud not be fetched!')
    } else {
      return response.json()
    }
  }
  useEffect(() => {
    
    fetchData()
      .then((res) => {
        initPois(res.success)
        console.log(res.success.extras._content_points.value)
      })
      
      .catch((e) => {
        console.log(e.message)
      })
  },[languageCtx.languageCode])
  const settings = {
    dots: true,
    arrows:true,
    autoplay: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode:true,
    adaptiveHeight:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }
    return (
      <div>
       <div className="container">
        <Slider {...settings}>
        {pois.map(poi =>
        <div className="relroute">
          <MapRouteThumb id={poi.id}/>
          <div className="routetag"> {poi.name} </div>
          <div className="routetitle"> <a href= {"/route/" + poi.id}>{poi.extras._subtitle.value} </a></div>
          <div className="mcolumns measurements">
                { poi.extras._distance.value &&
                <div className="mcolumn">
                  <Fragment> 
                    <div>{t("Απόσταση")} </div>
                    <span><img src="assets/images/icons-distance.png" alt="folegandros logo" /><div dangerouslySetInnerHTML={ { __html: poi.extras._distance.value.replace(",","<br />")} }></div></span>
                  </Fragment>
                  </div>
                  }
                  { poi.extras._time.value &&
                  <div className="mcolumn">
                  <Fragment> 
                    <div>{t("Χρόνος")} </div>
                    <span><img src="assets/images/icons-alarm-2.png" alt="folegandros logo" /><div dangerouslySetInnerHTML={ { __html: poi.extras._time.value.replace(",","<br />")} }></div></span>
                  </Fragment>
                  </div>
                   }
                   { poi.extras._difficulty.value &&
                  <div className="mcolumn">
                  <Fragment> 
                    <div>{t("Βαθμίδα")} </div>
                    <span><img src="assets/images/icons-like.png" alt="folegandros logo" /><div dangerouslySetInnerHTML={ { __html: poi.extras._difficulty.value.replace(",","<br />")} }></div></span>
                  </Fragment>
                  </div>
                }
          </div>
        </div>
        )}
        </Slider>
      </div>
      </div>
    );
}

export default SuggestedRoutes;